import { createRef, useEffect, useRef, useState } from "react";
import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext";
// import { BindDataToComponents } from "vagaro-website-rendering/src/components/Utilities/BindDataToComponents";
// import { GeneratePublishHTMLString } from "vagaro-website-rendering/src/components/Utilities/GeneratePublishHTMLString";
// import { RenderWBComponent } from "vagaro-website-rendering/src/components/Utilities/RenderWBComponent";


import { SiteData } from "components/WebDesigner/Data/SiteData";
import BindDataToComponents from "vagaro-website-rendering/src/components/Binding/BindDataToComponents";
import { GeneratePublishForSingleNode, GeneratePublishHTMLString } from "./GeneratePublishHTMLString";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { AlertConfirm } from "./ConfirmationPopups";
import { LoadPageContentAsync, adminLogoData } from "./Utilities/PageDataHandler";
import { CreateBlankLayoutNode } from "./WBCanvas";
import Loader from "vagaro-website-rendering/src/components/Common/Loader";
import generateGlobalStyleFromSiteData from "vagaro-website-rendering/src/components/Utilities/GenerateGlobalStyleFromSiteData";
import ReactDOMServer from "react-dom/server";
import AnnouncementBanner from "./WBComponents/AnnoucementBanner";
import { ClosestWithClass } from "vagaro-website-rendering/src/components/Utilities/HTMLHelpers";


export default function StaticRender({root,userContext,siteData,onPostBind,onChangePageOverride}:{root:LayoutNode,userContext:UserContext,siteData:SiteData,onPostBind?:Function,onChangePageOverride?:(pageId:string)=>void}){

    (window as any).isEditor = true;
    const [rootState,setRootState] = useState<LayoutNode>(root);
    const newContext = useRef<UserContext>({...userContext});

    siteData.userContext = userContext;
    const screenSizeState = useRef(0);
    //eslint-disable-next-line
    const [screenState,setScreenState] = useState(ScreenSize.Desktop);
    const setScrenSize = (size:number)=>{ screenSizeState.current = size}
    const [firstLoad,setFirstLoad] = useState(true);

    const [isLoadingPage,setIsLoadingPage] = useState(false);
    const observer = useRef<ResizeObserver | null>(null);
    const ref = createRef<HTMLDivElement>();
    const isDuplicated = useRef(false);
    const prevSize = useRef<number>(0); // store previous size outside of state to prevent re-renders/loops and avoid edge case flickering
   
    

    const evalSize = (size:number)=>{

        let prev = prevSize.current;
        let newScreenSize = ScreenSize.Desktop;
        
        if(size<=768 ){
    
          
            newScreenSize = ScreenSize.Mobile;
            
           
        }
        else if(size<=1200) {
        
            newScreenSize = ScreenSize.Tablet;
        }
        else{
      
            newScreenSize = ScreenSize.Desktop;
        }
    
        if(prev!==newScreenSize){

            prevSize.current = newScreenSize;
     
            setScrenSize(newScreenSize);
            setScreenState(newScreenSize);
           setTimeout(()=>{ // sometimes when updating the states the binded navbar gets reset so we need to bind every time we update state..
                BindDataToComponents(userContext.businessId,userContext.accessToken,userContext.MultilocationData,userContext.bidHash,userContext.tokenExpiresAt,userContext.isMysite,undefined,"",false,userContext.sitebid);

  
           })
           
        }

    }

    //resizing
    useEffect( ()=>{
        
        if (!observer.current) {
        observer.current = new ResizeObserver((entries) => {
          
            window.requestAnimationFrame(() => { // ONCE PER FRAME!
                const rect = entries[0].contentRect;
                evalSize(rect.width);
                });
          });
        }

        if(ref.current){
          
        observer.current.observe(ref.current);
        }

        return ()=>{
            if(observer.current)
            observer.current.disconnect();
        }

    })

    //Animations
    useEffect(()=>{



        const options = {
            rootMargin: "0px",
            threshold: 0.0,
          };
          
          const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if(entry.isIntersecting){
             
                    let animation = entry.target.getAttribute("vanimation");
                    if(animation){
                        entry.target.classList.add("vanimation-"+animation);
                    }
                }
            })
          }, options);


          let toAnimate = (ref.current)?ref.current.querySelectorAll("[vanimation]"):document.querySelectorAll("[vanimation]");
     
          for(let i = 0;i<toAnimate.length;i++){
                observer.observe(toAnimate[i]);
                let animation = toAnimate[i].getAttribute("vanimation");
                if(animation){
                    toAnimate[i].classList.remove("vanimation-"+animation);
                }
                toAnimate[i].classList.add("vanimation-hidden");
        }

        return ()=>{ observer.disconnect();
        
        let toAnimate = document.querySelectorAll(".vanimation-hidden");
        for(let i = 0;i<toAnimate.length;i++){
            toAnimate[i].classList.remove("vanimation-hidden");
        }
        
        }
    })


    const OpenPreviewLocation = (bid:string,url:string)=>{

        newContext.current.businessId = bid;
        ChangePage(url);
        let dom = document.getElementById("preview-content");
        if(dom)
            dom.scrollTop = 0; 

    }


    //store ref in window object for location picker to interact with
    
    (window as any).OpenPreviewLocation = OpenPreviewLocation;

    const ChangePage = (url:string)=>{

        if(onChangePageOverride){
            onChangePageOverride(url);
            return;
        }

        setIsLoadingPage(true);
        for(let i = 0;i<userContext.pages.length;i++){

            const pg = userContext.pages[i];
            if(pg.isFolder&&pg.children&&pg.children.length>0){

                for(let ii = 0;ii<pg.children.length;ii++){
                    if(pg.children[ii].url===url){
                        LoadIntoPage(pg.children[ii].pageId,pg.isDuplicateAllLocationPage)
                        return;
                    }
                }
            }
            else{
                if(pg.url===url){
                    LoadIntoPage(pg.pageId,pg.isDuplicateAllLocationPage)
                    return;
                }
            }
        }
      
        setIsLoadingPage(false);//didn't find page

    }

    const applyParentRecursively = (node:LayoutNode,parent?:LayoutNode)=>{

        if(parent)
        node.parent = parent;
        for(let i = 0;i<node.children.length;i++){
            applyParentRecursively(node.children[i],node);
        }
    }

    const LoadIntoPage = async (pageId:string,isMulit:boolean|undefined = false)=>{

        if(isMulit){
            isDuplicated.current = true;
        }
        else{
            isDuplicated.current = false;
        }

        (window as any).currentvpage = pageId;
   
        LoadPageContentAsync(userContext,pageId,(data)=>{
            try{
                let contentString = data.data.data.content;
                
                let layout = (contentString)?JSON.parse(data.data.data.content):CreateBlankLayoutNode(wBComponentTypeNames.pageRoot) ;
                let headerString:string = data.data.data.header;
                let footerString:string = data.data.data.footer;

                if(headerString){
                    headerString = headerString.replaceAll(adminLogoData.imagePath,siteData.logoUrl??adminLogoData.imagePath);
                    footerString = footerString.replaceAll(adminLogoData.imagePath,siteData.logoUrl??adminLogoData.imagePath);
                }

                let header = JSON.parse(headerString??JSON.stringify(CreateBlankLayoutNode(wBComponentTypeNames.navigationBar)));
                let footer = JSON.parse(footerString??JSON.stringify(CreateBlankLayoutNode(wBComponentTypeNames.footer)));

                layout.children.unshift(header);
                layout.children.push(footer);

                setTimeout(()=>{window.scrollTo(0,0)
                
                    if(ref.current){
                        ref.current.scrollTop = 0;
                    }
                },0);
                


                applyParentRecursively(layout);
           
                setRootState(layout);
                setIsLoadingPage(false);
                setFirstLoad(true);
              
            }
            catch(e){
                AlertConfirm("Error loading page. Please try again later.")
                console.warn(e);
                setIsLoadingPage(false);
            }

        },(data)=>{ AlertConfirm("Error loading page. Please try again later."); console.warn("exception:",data);  setIsLoadingPage(false); });

    }

    const updateEmbedsForPreivew = ()=>{

        if(!ref.current)
            return

        let embeds = ref.current.querySelectorAll(".v-html-embed iframe");

        for(let i = 0;i<embeds.length;i++){
            let e = embeds[i] as HTMLIFrameElement;
            e.srcdoc = e.srcdoc.replaceAll("&quot;",'"');
      
        }


    }

    const preventClicks = (e:any)=>{
        
            let target = e.target as HTMLElement;

            if(target.classList.contains("location-box") || ClosestWithClass(target,"location-box")){ // allow location picker to handle it's on clicks
   
                return;
            }
       
            let h = "";
            while(target.parentElement){
                let href = target.getAttribute("href");
                if(href){
                    h = href;
                    break;
                }
                target = target.parentElement;
            }

            if(h.length<=0){
                return;
            }
            e.stopPropagation();
            e.stopImmediatePropagation();
            e.preventDefault();
            if(h=="./"){ // home page link imediately redirect to home page

                if(onChangePageOverride){
                    onChangePageOverride(h);
                    return;
                }

                setIsLoadingPage(true);
                LoadIntoPage(siteData.homePageId);
                return;
            }
            let split = h.split("#");
            if(split.length>1){
                     let target = document.getElementById(split[split.length-1]);
                     if(target){
                         target.scrollIntoView({behavior:"smooth"});
                         return;
                     }
             }


             let url = h.split("/").pop()??"#";

            ChangePage(url);

        }
    
    


    //Binding
    useEffect(()=>{

        //timeout nessesary to avoid React Warnings since we are updateing a react components children when in preview mode. Final render will be done by server in CSHTML
        if(firstLoad){ 
            
            
            setTimeout(()=> { 
                
                if(isDuplicated){ // if we are on a duplicated page clear all bids.
                    let encoded = document.querySelectorAll("[encbid]");
                    for(let i = 0;i<encoded.length;i++){
                        let e = encoded[i] as HTMLElement;
                        e.setAttribute("encbid","");
                    }
                }
                BindDataToComponents(newContext.current.businessId,userContext.accessToken,userContext.MultilocationData,userContext.bidHash,userContext.tokenExpiresAt,userContext.isMysite,undefined,"",false,userContext.sitebid); },10);
            updateEmbedsForPreivew();
        
           

            setFirstLoad(false);
            if(onPostBind)
            onPostBind();
         }


//eslint-disable-next-line
    },[firstLoad])

    useEffect(()=>{
        if(ref.current){
            ref.current.addEventListener("click",preventClicks)
        }

        let dropdown = document.getElementById("btn-dropdown-container");
       
        if(!dropdown){
            dropdown = document.createElement("div");
            dropdown.id = "btn-dropdown-container";
            document.body.appendChild(dropdown);
        }

        if(dropdown){

            dropdown.addEventListener("click",(e)=>{e.preventDefault();})
            dropdown.addEventListener("click",preventClicks);
        }

        return (()=>{
            //eslint-disable-next-line
            if(ref.current){//eslint-disable-next-line
                ref.current.removeEventListener("click",preventClicks)
            }
            let dropdown = document.getElementById("btn-dropdown-container");

            if(dropdown){

                dropdown.removeEventListener("click",preventClicks);
            }
        });
//eslint-disable-next-line
    },[]);


 



    let breakClass ="screen-desktop";
    if(screenSizeState.current===ScreenSize.Mobile)
    breakClass = "mobile-break tablet-break screen-mobile";
    else if(screenSizeState.current===ScreenSize.Tablet)
    breakClass = "tablet-break screen-tablet";

    let hString = (rootState.children[0].typename===wBComponentTypeNames.navigationBar)? GeneratePublishForSingleNode(rootState.children[0],siteData,true,"h"):"";

    const annoucmentString =  ReactDOMServer.renderToString(<AnnouncementBanner pageData={siteData.pages} atts={siteData.siteStyling.announcementBar} inId="close-announcement-btn"/>);


    if(hString.includes("fixed-above")){
        hString.replaceAll("fixed-above","");
        hString = `<div class="fixed-above w-full fixed-container">${annoucmentString+hString}</div>`
    }
    else{
        hString = `<div class="fixed-above w-full fixed-container">${annoucmentString}</div>`+hString;
    }
    
    const htmlString = GeneratePublishHTMLString(rootState,siteData,false);

    const fString = (rootState.children[rootState.children.length-1].typename===wBComponentTypeNames.footer)?GeneratePublishForSingleNode(rootState.children[rootState.children.length-1],siteData,true,"f"):"";

    return (
        <>
        <style>{generateGlobalStyleFromSiteData(siteData.siteStyling,undefined,false)}</style>
        <div className={"v-site render "+(breakClass)} ref={ref} dangerouslySetInnerHTML={{__html:(hString+ htmlString+fString).replaceAll("&#x27;","\"")}}> 
        </div>
        {isLoadingPage && <Loader/>}
        </>
    )
}





